import { SoftConfigThemeSchema } from '@tumelo/designsystem'
import React from 'react'
import { ThemeProvider } from 'styled-components'

export const StyledComponentsThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider theme={SoftConfigThemeSchema.parse()}>
      <>{children}</>
    </ThemeProvider>
  )
}
